import { ArdoqId } from '@ardoq/api-types';
import { returnZero } from '@ardoq/common-helpers';
import { getComponentLabelParts } from './getComponentLabelParts';
import { truncateComponentLabel } from './truncateComponentLabel';

/** The component's fully assembled label, with no truncation. */
export const getFullComponentLabel = (
  componentId: ArdoqId,
  labelsInterface?: Parameters<typeof getComponentLabelParts>[1]
): string =>
  truncateComponentLabel({
    ...getComponentLabelParts(componentId, labelsInterface),
    width: Infinity,
    measure: returnZero,
  });
